<template>
  <Modal v-model="visible" width="460px" :title="formData.id?'编辑职级':'新增职级'" :footer-hide="true" :mask-closable="false" class="my-modal top">
    <Form ref="form" :model="formData" :label-width="90" class="page-form formGauge">
      <FormItem prop="name" label="职级名称" class="full" :rules="$units.formRule.required('请输入职级名称')">
        <Input v-model="formData.name" placeholder="请输入"/>
      </FormItem>
      <FormItem prop="remark" label="备注" class="full">
        <Input v-model="formData.remark" placeholder="请输入" type="textarea"/>
      </FormItem>
      <FormItem prop="level" label="职级等级" class="full" :rules="$units.formRule.required('请输入职级等级')">
        <Input v-model="formData.level" type="number" placeholder="仅支持输入数字 数字越大等级越高"/>
      </FormItem>
    </Form>
    <div class="ivu-modal-footer">
      <Button type="text" @click="visible=false">取消</Button>
      <Button type="primary" @click="submit" :loading="loading">提交</Button>
    </div>
  </Modal>
</template>

<script>
export default {
  components: {
  },
  props: [],
  data() {
    return {
      visible: false,
      loading:false,
      formData:{
        name:"",
        remark:"",
        level:'',
      },
    };
  },
  created() {},
  methods: {
    open(data={}) {
      this.$refs.form&&this.$refs.form.resetFields();
      const formData = JSON.parse(JSON.stringify(data));
      this.formData = formData;
      this.visible = true;

    },
    submit(){
      console.log("validate")
      this.$refs.form.validate().then(isok=>{
        if(!isok){
          return;
        }
        const formData = JSON.parse(JSON.stringify(this.formData));
        if(this.loading){
          return;
        }
        this.loading = true;
        this.$http({
          type: "POST",
          url: formData.id?"/buz/baseRank/edit":"/buz/baseRank/add",
          data: formData,
          apiPermissionCode:'org_3_2'
        }).then(res => {
          this.$notice.success("提交成功");
          this.visible = false;
          this.$emit("reload")
        }).finally(res => {
          this.loading = false;
        });

      })
    },
  },
};
</script>
<style lang="scss" scoped>

</style>
